import sizesTemplate from '../templates/sizes.html';
import sizesSelectTemplate from '../templates/sizesSelect.html';
function sizesViewerDirective() {
    return {
        restrict: 'A',
        replace: true,
        templateUrl: (element, attrs) => (attrs?.controlType === 'select' ? sizesSelectTemplate : sizesTemplate),
        controller: 'SizesViewerCtrl',
        controllerAs: 'sizesViewer',
        bindToController: true,
        scope: {
            sizes: '<?',
            sizeSelected: '=?',
            initSizes: '&',
            changeSize: '&',
            startSelectedSizes: '<?',
            controlType: '@',
            isCombo: '<?',
            needGlider: '<?',
        },
        link: function (scope, element, attrs, ctrl) {
            scope.$watch(
                'sizesViewer.sizeSelected',
                function (newVal) {
                    if (newVal && ctrl.sizes) {
                        const index = ctrl.sizes.findIndex((s) => s.SizeId === newVal.SizeId);
                        if (index !== -1) {
                            ctrl.selectedIndex = index;
                        }
                    } else {
                        ctrl.selectedIndex = 0;
                    }
                },
                true,
            );
        },
    };
}

export { sizesViewerDirective };
